import { FC } from 'react'

import { LoadingButton } from '@mui/lab'
import { css, styled } from '@mui/material'
import { match } from 'ts-pattern'

module Slot {
  export const Button = styled(LoadingButton)`
    min-width: 12rem;
    height: 3.6rem;

    ${({ variant, theme }) =>
      // TODO: 挪到 theme 中统一设置颜色
      variant === 'outlined' &&
      css`
        color: ${theme.palette.text.secondary};
        border-color: ${theme.perMode('hsl(0, 0%, 88%)', 'hsl(0, 0%, 24%)')};
      `}
  `
}

// TODO: 可以直接在 theme 中定义对应的变体
export const DialogButton: FC<{
  variant: 'primary' | 'secondary'
  disabled?: boolean
  loading?: boolean
  onClick?: () => void
}> = (props) => {
  const buttonProps = match(props.variant)
    .with('primary', () => ({ variant: 'contained' } as const))
    .with('secondary', () => ({ variant: 'outlined' } as const))
    .exhaustive()
  return (
    <Slot.Button {...buttonProps} disabled={props.disabled} loading={props.loading} onClick={props.onClick}>
      {props.children}
    </Slot.Button>
  )
}
